export function redirectFromLegacyRoute() {
  const legacyPath = window.location.hash.replace('#', '')

  if (legacyPath && window.location.pathname === '/') {
    window.location.href = legacyPath
  }
}
